import { Segmented as AntdSegmented, SegmentedProps as AntdSegmentedProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export type SegmentedProps = AntdSegmentedProps & {'data-test'?: string;};

const Segmented: React.FC<SegmentedProps> = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdSegmented {...props} data-test={props['data-test']} data-asper-segmented/>
        </ConfigProvider>
    );
};

export default Segmented;
